export const setItemToLocalStorage = (key: string, object: {}) => {
  window.localStorage.setItem(key, JSON.stringify(object));
};
